package com.neurobs.aws

import com.neurobs.ccab.{IdentityData, IdentityGroup}
import com.neurobs.util.Guid
import com.neurobs.util.JsonPrinter.fromJson
import io.circe.{Decoder, Encoder}

import scala.util.Try

object CognitoIdentityData {
	val ATTRIBUTE_NAME_EMAIL = "email"
	val ATTRIBUTE_NAME_GIVEN_NAME = "given_name"
	val ATTRIBUTE_NAME_FAMILY_NAME = "family_name"
	val ATTRIBUTE_NAME_USER_UUID = "custom:user_uuid"
	val ATTRIBUTE_NAME_ACCOUNT_UUID = "custom:account_uuid"
	val ATTRIBUTE_NAME_GROUPS = "cognito:groups"
	val ATTRIBUTE_NAME_LEGACY_ACCOUNT_ID = "custom:legacy_account_id"
	val ATTRIBUTE_NAME_LEGACY_USER_ID = "custom:legacy_user_id"
	val ATTRIBUTE_NAME_EMAIL_VERIFIED = "email_verified"

	def toIdentityData(attributeSource: String => Option[String]): Option[IdentityData] = {
		def getOptional(name: String): Option[String] = {
			attributeSource(name) match {
				case None => Some("")
				case v => v
			}
		}
		for {
			userGuid <- attributeSource(ATTRIBUTE_NAME_USER_UUID).flatMap(Guid.apply)
			accountGuid <- attributeSource(ATTRIBUTE_NAME_ACCOUNT_UUID).flatMap(Guid.apply)
			email <- attributeSource(ATTRIBUTE_NAME_EMAIL)
			givenName <- getOptional(ATTRIBUTE_NAME_GIVEN_NAME)
			familyName <- getOptional(ATTRIBUTE_NAME_FAMILY_NAME)
			legacyAccountId <- attributeSource(ATTRIBUTE_NAME_LEGACY_ACCOUNT_ID).flatMap(s => Try(s.toLong).toOption)
			legacyUserId <- attributeSource(ATTRIBUTE_NAME_LEGACY_USER_ID).flatMap(s => Try(s.toLong).toOption)
			groups <- attributeSource(ATTRIBUTE_NAME_GROUPS).flatMap(fromJson[Seq[IdentityGroup.Value]])
		} yield IdentityData(
			userUuid = userGuid,
			accountUuid = accountGuid,
			email = email,
			givenName = givenName,
			familyName = familyName,
			legacyAccountId = legacyAccountId,
			legacyUserId = legacyUserId,
			groups = groups
		)
	}

	implicit val notificationTypeDecoder: Decoder[IdentityGroup.Value] = Decoder.decodeEnumeration(IdentityGroup)
	implicit val notificationTypeEncoder: Encoder[IdentityGroup.Value] = Encoder.encodeEnumeration(IdentityGroup)
}
